import React from "react";
import { Truncatable } from "@fidget/common/components/surfaces/truncatable/truncatable";
import styles from "./mainNotification.css";

interface Props {
  text: string;
}

const MAX_HEIGHT = 40; // 2 * line-height (20)

export const MainNotification = ({ text }: Props) => {
  return (
    <Truncatable initialIsOpen maxHeight={MAX_HEIGHT} className={styles.container}>
      <p className={styles["text-container"]}>{text}</p>
    </Truncatable>
  );
};
